var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCallus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#DB0A40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0877 30.5347L32.6111 36.3632C33.2099 36.9952 34.2945 37.0854 35.5027 36.4899C38.5777 35.2151 39.6007 34.9043 40.1848 35.5206L46.534 42.2205C47.2846 43.0125 47.0843 44.3317 46.245 45.2173C41.887 49.816 34.8037 49.816 30.4458 45.2173L18.5851 32.7016C14.249 28.1259 14.249 20.7234 18.5851 16.1478C19.4421 15.2435 20.7581 15.0209 21.5369 15.8428L27.8862 22.5427C28.4365 23.1234 28.1414 24.205 26.9399 27.4278C26.3814 28.6858 26.4709 29.8839 27.0877 30.5347Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallus);
export default __webpack_public_path__ + "static/media/Icon_callus.de445fe371eeca669e16ad09caaa8613.svg";
export { ForwardRef as ReactComponent };